export default __webpack_public_path__ + "static/media/berlin-2.d23a6cdc.jpg";